export const baseUrl = `${process.env.REACT_APP_API_PROTOCOL}://${process.env.REACT_APP_API_HOST}/api/v1`;
export const baseUrl_V2 = `${process.env.REACT_APP_API_PROTOCOL}://${process.env.REACT_APP_API_HOST}/api/v2`;
export const domainName = `${process.env.REACT_APP_DOMAIN}`;
export const domainName_v2 = `${process.env.REACT_APP_DOMAIN_ADDED}`;
export const WEBAPPLINK = `${process.env.REACT_APP_WEBAPP_PROTOCOL}://${process.env.REACT_APP_WEBAPP_LINK}`;
export const environment = process.env.REACT_ENV;
export const FACTSHEET = `${process.env.REACT_APP_WEBAPP_PROTOCOL}://${process.env.REACT_APP_API_HOST}`;